// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Loader__Loader__2iSOk","load1":"Loader__load1__1d7HO"};